import Vuex from 'vuex'
import Vue from 'vue'
// import VuexPersist from 'vuex-persist'

//const vuexPersist = new VuexPersist({
//    key: 'quickcheck:state',
//    storage: window.localStorage
//})

let vuexPlugins = []

//if (process.env.NODE_ENV !== 'production') {
// vuexPlugins = [
//    vuexPersist.plugin
// ]
//}

import { getField, updateField } from 'vuex-map-fields'

Vue.use(Vuex)

export default new Vuex.Store({
    plugins: vuexPlugins,
    state: {
        sourcecode: 'WEB',
        productId: '',
        fadcode: '',
        person: {
            title: '',
            firstName: '',
            lastName: '',
            birthDate: '',
            mobilePhoneNumber: '',
            emailAddress: '',
            ukResidencyCode: '',
            residentialStatusCode: '',
            employmentStatusCode: '',
            numberOfDependents: '',
            incomeAmount: '',
            monthlyOutgoings: '',
            additionalIncomeIndicator: '',
            otherHouseholdIncome: '',
            cashAdvanceIndicator: '',
            occupation: '',
            marketingConsent: {
                directMailOptIn: 'N',
                textOptIn: 'N',
                phoneOptIn: 'N',
                emailOptIn: 'N',
                consentDate: new Date().toISOString()
            },
            currentAddress: null,
            previousAddress: null,
        },
        creditRequested: {
            creditType: 'N',
            creditAmount: '',
        },
        internal: {
            campaign: '',
            pcr: '',
            outcome: {},
            payload: {}
        }
    },
    getters: {
        getField,
    },
    mutations: {
        updateField,
    },
})